import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from '../../../models/utilities/document-request';
import { AppliedFilterBarOpt } from '../../../models/utilities/filter-bar';
import { API_METHODS } from '../../../models/utilities/type-models';
import { ApiEndpoints } from '../../../utils/app-constants';
import { toCondensedDate } from '../../../utils/date-utils';
import { DeliveryPlanningFilters } from '../filters/delivery-planning-filters';
import { UnplannedRouteGroup } from './_index';

export class StopFileDocument implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'csv';
    public openInTab : boolean = false;
    public url : string = ''; 
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'POST';
    public data : any;

    constructor(filters : DeliveryPlanningFilters, selectedIds : UnplannedRouteGroup[]) {

        const payload : any = {};
        filters.appliedFilters.forEach((itm: AppliedFilterBarOpt) => {

            // Process the areas query
            if (itm.qsName === 'areas') {
                if (!payload.areas || payload.areas.length === 0) {
                    payload.areas = itm.qsValue.toString();
                }
                else {
                    payload.areas += ',' + itm.qsValue.toString();
                }
            }

            // Process the maxCutoff which also has the DOW boolean
            if ( itm.qsName === 'maxCutoff') {

                const cutoffParts = itm.qsValue.split('&');
                payload.maxCutoff = cutoffParts[0];
                
                const dowParts = cutoffParts[1].split('=');
                payload.matchDayOfWeek = (dowParts[1].toLowerCase() === "true");
            }

            // Pull dealer ID
            if (itm.qsName === 'dealerId') {
                payload.dealerId = itm.qsValue;
            }

            // Pull order ID
            if (itm.qsName === 'orderId') {
                payload.orderId = itm.qsValue;
            }

            // Pull division
            if (itm.qsName === 'division') {
                if (!payload.division || payload.division.length === 0) {
                    payload.division = itm.qsValue.toString();
                }
                else {
                    payload.division += ',' + itm.qsValue.toString();
                }
            }
        });
    
        if (selectedIds) {

            const sels : any[] = [];
            selectedIds.forEach((itm :UnplannedRouteGroup) => {
                sels.push({
                    shipToAddressId: itm.shipToAddressId,
                    groupId: itm.orderGroupId
                });
            });

            payload.selections = sels;
        }

        this.url = ApiEndpoints.TRANSPORTATION_PLANNING_STOPFILE_V2;
        this.data = payload;
        this.filename = `Stops-${ toCondensedDate(new Date()) }`;
    }

}
